/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./Absolute',
	'../../../../lib/@waca/core-client/js/core-client/utils/Deferred'
], function(BaseLayout, Deferred) {


	var PageLayout = null;
	PageLayout = BaseLayout.extend({

		init: function(options) {
			PageLayout.inherited('init', this, arguments);

			this.services = options.services;
			this.specializeConsumeView(['setPreferredLocation']);
			this.$el.parent().addClass('templateDropZoneContainer');

			this.whenIsReadyDfd = new Deferred();
			this.whenIsReadyDfd.resolve();
		},

		// Override the absolute _initialize to prevent the creation of drop-zones and others ...
		_initialize: function() {
			// No-op
		},

		destroy: function() {
			this.$el.parent().removeClass('templateDropZoneContainer');

			PageLayout.inherited('destroy', this, arguments);
		},

		setPreferredLocation: function(options) {
			const parentId = this.model.getParent().id;
			PageLayout.inherited('setPreferredLocation', this, arguments);
			options.parentId = parentId;
		},

		getWidgetContainerNode: function() {
			return this.domNode.parentNode;
		}
	});

	return PageLayout;
});
